import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from './core/services/rest.service';
import { TokenStorage } from './core/services/token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'KenIndia-Web';
  defaultLanguage: string = 'en';
  timeInterval: any;
  receivedData: any;
  isModules = false;
  screenConfigId: any;
  url: any;
  orgAppScreens: any;
  showHelpIcon: boolean = false;
  orgHelpScreenData: string = '';
  private breadcrumbHistory: any[] = [];
  lastBreadcrumbIndex: number | null = null;
  isScrnConfig = false;
  menuID!: number;
  img!: string;
  isLogin: boolean = true;

  constructor(
    private titleService: Title,
    public Translate: TranslateService,
    private restService: RestService,
    private router: Router,
    private token: TokenStorage,
  ) {
    this.setLanguage(this.defaultLanguage); // Set the default language
  }


  ngOnInit(): void {
    // this.token.save(this.token.getJWTtoken());
    // this.token.saveRT(this.token.getRefreshToken());

    this.isLogin = window.location.pathname.includes('login') ? true : false;
  }

  shoulHideMenu() {
    return (
      this.router.url.includes('help-document-new') ||
      this.router.url.includes('auth/forgot_password') ||
      this.router.url.includes('error/error-status') ||
      this.router.url.includes('error/internal-error') ||  
      window.location.pathname.includes('auth/access') 
      // this.router.url.includes('auth/accessCode') 
    );
  }

  proposalLoginMenu(): boolean {
    return (this.router.url.includes('/auth/proposal-form-login') ||
      this.router.url.includes('/auth/proposal-form-getAll')
    )
  }

  setLanguage(language: string) {
    this.Translate.setDefaultLang(language); // Set default language
    this.Translate.use(language); // Use the specified language
  }
}

